export const PENDING_CHECKAUTH = 'PENDING_CHECKAUTH';
export const FAILED_CHECKAUTH = 'FAILED_CHECKAUTH';
export const SUCCESSFULLY_CHECKAUTH = 'SUCCESSFULLY_CHECKAUTH';
